"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _usePortal = require("../../_helpers/usePortal");

var _ = require("../..");

var _reactSpring = require("react-spring");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./AlertModal.css");

var _styles = {
  "container": "AlertModal__container___2DgIB",
  "show": "AlertModal__show___3gVE5",
  "title-bar": "AlertModal__title-bar___2Vxz7",
  "animated-container": "AlertModal__animated-container___30zMm",
  "backdrop": "AlertModal__backdrop___39Ptr"
};

const styles = _bind.default.bind(_styles);

const AlertModal = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  showModal,
  title,
  message,
  maxWidth,
  actionButtonLabel = 'OK',
  closeToggle
}) => {
  const transitions = (0, _reactSpring.useTransition)(showModal, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  const composed_classname = (0, _bind.default)(styles('container', {
    show: showModal
  }), className);
  return _react.default.createElement(_usePortal.Portal, {
    id: 'root'
  }, transitions((props, item) => {
    return item && _react.default.createElement(_reactSpring.animated.div, {
      "data-testid": dataTestId,
      className: styles('animated-container'),
      style: props
    }, _react.default.createElement("div", {
      "data-testid": dataTestId && `${dataTestId}-backdrop`,
      className: styles('backdrop', {
        show: showModal
      }),
      onClick: closeToggle
    }), _react.default.createElement(_.Card, {
      className: composed_classname,
      maxWidth: maxWidth
    }, title && _react.default.createElement("div", {
      className: styles('title-bar')
    }, typeof title === 'string' ? _react.default.createElement(_.Text, {
      dataTestId: dataTestId && `${dataTestId}-title`,
      size: 15,
      variant: 'medium',
      text: title
    }) : title, _react.default.createElement(_.Icon, {
      dataTestId: dataTestId && `${dataTestId}-close-button`,
      name: _.IconEnum.x_mark,
      onClick: closeToggle
    })), _react.default.createElement(_.Content, {
      paddingTopBottom: 24,
      paddingLeftRight: 24,
      flex: true,
      flexDirection: 'column',
      gap: 32
    }, typeof message === 'string' ? _react.default.createElement(_.Text, {
      size: 15,
      text: message,
      dataTestId: dataTestId && `${dataTestId}-message`
    }) : message, _react.default.createElement(_.Content, {
      flex: true,
      alignItems: 'center',
      justifyContent: 'center'
    }, _react.default.createElement(_.Button, {
      small: true,
      label: actionButtonLabel,
      onClick: closeToggle,
      dataTestId: dataTestId && `${dataTestId}-action-button`
    })))));
  }));
});
var _default = AlertModal;
exports.default = _default;